export interface ILogModule {
  id: number;
  label: string;
  title: string;
}

export const moduleTypes: ILogModule[] = [
  { id: 1, label: "channel", title: "Channel" },
  { id: 2, label: "user", title: "User" },
  { id: 3, label: "software", title: "Software" },
  { id: 4, label: "channelManager", title: "Channel manager" },
  { id: 5, label: "licenseManager", title: "License manager" },
  { id: 6, label: "api", title: "API" },
  { id: 7, label: "snmp", title: "SNMP" },
  { id: 8, label: "maintenance", title: "Maintenance" },
  { id: 9, label: "email", title: "EMAIL" },
];
